import { UseFormPayload, useSetState } from '@domain-group/react-hooks'

import {
  Box, DashboardModule, Form, Link,
} from '@domain-group/suit-theme'

import EntitySelector from '@components/EntitySelector'
import Markdown from '@components/Markdown'
import TrainingLessonAliasSelector from '@components/TrainingLessonAliasSelector'

import { TrainingLessonModel } from '@domain-group/realhub-backend-api-types'

const defaultState = {
  isPreview: false,
}
interface TrainingLessonDetailsProps {
  trainingLessonFormPayload: UseFormPayload,
  urls: {
    linkUrl?:string,
  },
}

const TrainingLessonDetails = (props: TrainingLessonDetailsProps) => {
  const { trainingLessonFormPayload, urls: { linkUrl } } = props

  const [state, setState] = useSetState(defaultState)
  const { isPreview } = state

  const {
    entityState,
    entityState: {
      description,
      title,
      training_module_id,
    },
    errors,
    handlers,
    setEntityState,
  } = trainingLessonFormPayload

  return (
    <DashboardModule title="Training Lesson Details">
      <Form padding="large">
        <EntitySelector
          // @ts-expect-error TS2739
          callbacks={{}}
          disabled
          endpoint="training_modules"
          entityKey="trainingModules"
          goToHref={linkUrl}
          label="Module"
          // @ts-expect-error TS2322
          marginTop={['large', 0]}
          selectedItemId={training_module_id}
        />

        <Form.Row marginTop="large">
          <Form.Field label="* Title" errorMessage={errors.title}>
            <input type="text" name="title" value={title} {...handlers} />
          </Form.Field>

          <TrainingLessonAliasSelector
            callbacks={{
              selectTrainingLesson: (lesson: TrainingLessonModel) => {
                setEntityState({ lesson_alias_id: lesson?.id || null })
              },
            }}
            url={linkUrl}
            currentTrainingLesson={entityState}
          />
        </Form.Row>

        <Form.Field
          direction="column"
          label="Lesson Description"
          labelRight={(
            <Link onClick={() => setState({ isPreview: !isPreview })} textProps={{ fontSize: 'xsmall' }}>
              {!isPreview ? 'Preview' : 'Edit'}
            </Link>
            )}
          marginTop="large"
        >
          {isPreview ? (
            <Box minHeight="100px" overflowY="auto" padding="medium" variant="white">
              <Markdown source={description} />
            </Box>
          ) : (
            <textarea
              onChange={e => setEntityState({ description: e.target.value })}
              style={{ minHeight: 100 }}
              value={description}
            />
          )}
        </Form.Field>
      </Form>
    </DashboardModule>
  )
}

export default TrainingLessonDetails
